import { render, staticRenderFns } from "./seriesinfolist.vue?vue&type=template&id=e84482f4&scoped=true&"
import script from "./seriesinfolist.vue?vue&type=script&lang=js&"
export * from "./seriesinfolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84482f4",
  null
  
)

export default component.exports